import { render, staticRenderFns } from "./noRight.vue?vue&type=template&id=464e8b4a&scoped=true"
import script from "./noRight.vue?vue&type=script&lang=js"
export * from "./noRight.vue?vue&type=script&lang=js"
import style0 from "./noRight.vue?vue&type=style&index=0&id=464e8b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e8b4a",
  null
  
)

export default component.exports